import React from 'react';
import './Services.css'; // Don't forget to import the CSS file

function Home() {
    return (
        <div className="services">
            <h1>Our Specialization</h1>
            <p>From website design to full-stack development, we offer a variety of services to help you succeed in the digital world. Our services include:</p>

            <div className="service-cards">
                <div className="card">
                    <h2>Web Design & Development</h2>
                    <p>We create stunning websites that are responsive, fast, and user-friendly to ensure your online presence stands out.</p>
                </div>
                <div className="card">
                    <h2>E-commerce Solutions</h2>
                    <p>Our e-commerce platforms are designed to help you sell online, increase conversions, and offer an excellent customer experience.</p>
                </div>
                <div className="card">
                    <h2>SEO Optimization</h2>
                    <p>We implement SEO best practices to improve your website's visibility and drive more organic traffic from search engines.</p>
                </div>
                <div className="card">
                    <h2>Mobile App Development</h2>
                    <p>Our team builds mobile apps that provide exceptional user experiences on both Android and iOS platforms.</p>
                </div>
            </div>
        </div>
    );
}

export default Home;
